import React from "react"

import { s } from "../../../utilities/common"

export const AlertIcon = () => {
  return (
    <svg
      width={s("148")}
      height={s("148")}
      viewBox="0 0 148 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M21.7066 21.645C11.3495 31.9906 4.29351 45.1757 1.43141 59.5322C-1.43068 73.8887 0.0296777 88.7715 5.62771 102.298C11.2258 115.824 20.71 127.386 32.8805 135.522C45.051 143.657 59.3608 147.999 73.9998 148V138.75C65.4967 138.75 57.077 137.075 49.2212 133.821C41.3654 130.567 34.2273 125.798 28.2147 119.785C22.2021 113.773 17.4328 106.635 14.1788 98.7787C10.9248 90.9229 9.24984 82.5031 9.24984 74C9.24984 65.4969 10.9248 57.0771 14.1788 49.2213C17.4328 41.3654 22.2021 34.2274 28.2147 28.2148C34.2273 22.2022 41.3654 17.4328 49.2212 14.1788C57.077 10.9249 65.4967 9.25 73.9998 9.25V0C54.3893 0.000915527 35.5811 7.78592 21.7066 21.645Z"
        fill="white"
      />
      <path
        opacity="0.8"
        d="M74 0V9.25C82.5031 9.25 90.923 10.9249 98.7788 14.1788C106.635 17.4328 113.773 22.2022 119.785 28.2148C125.798 34.2274 130.567 41.3654 133.821 49.2213C137.075 57.0771 138.75 65.4969 138.75 74C138.75 82.5031 137.075 90.9229 133.821 98.7787C130.567 106.635 125.798 113.773 119.785 119.785C113.773 125.798 106.635 130.567 98.7788 133.821C90.923 137.075 82.5031 138.75 74 138.75V148C93.626 148 112.448 140.204 126.326 126.326C140.204 112.448 148 93.626 148 74C148 54.374 140.204 35.5518 126.326 21.6741C112.448 7.79645 93.626 0 74 0Z"
        fill="white"
      />
      <rect
        x="67.8334"
        y="37"
        width="12.3333"
        height="49.3333"
        fill="#D0D2D6"
      />
      <rect
        width="12.3333"
        height="12.3333"
        transform="matrix(1 8.74227e-08 8.74228e-08 -1 67.8334 111)"
        fill="#D0D2D6"
      />
    </svg>
  )
}
